import { lazyLoad } from 'utils/loadable';

export const NewsLetterPage = lazyLoad(
  () => import('./index'),
  module => module.NewsLetterPage,
);
